import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    TITLE: {
        id: 'notification.title',
        defaultMessage: 'E-mail Notification Setting'
    },
    STATUS_NOTIFICATION: {
        id: 'notification.status.notification',
        defaultMessage: 'Status Notifications'
    },
    SEGMENT_NOTIFICATION: {
        id: 'notification.segment.notification',
        defaultMessage: 'Segment Notifications'
    },
    STATUS_PLACEHOLDER: {
        id: 'notification.status.placeholder',
        defaultMessage: 'Select Statuses...'
    },
    SEGMENT_PLACEHOLDER: {
        id: 'notification.segment.placeholder',
        defaultMessage: 'Select Segments...'
    },
    SUBJECT_PLACEHOLDER: {
        id: 'notification.subject.placeholder',
        defaultMessage: 'Subject Segments...'
    },
});

export default messages;
